import { Button, Col, Space, Typography } from "antd";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { LoginLogo } from "./LoginLogo";
import { ProductContentLayout } from "../../components/log-in/ProductContentLayout";
import { useEffect, useState } from "react";

let TrialMessage;
let SwitchRegion;
try {
  TrialMessage = require("./TrialMessage").TrialMessage;
  SwitchRegion = require("./SwitchRegion").SwitchRegion;
} catch {
  // The component will remain undefined if it is not available
}

let SELECTED_PRODUCT;
let PRODUCT_NAMES;
let llmWhispererContentImage;
try {
  SELECTED_PRODUCT = require("../llm-whisperer/helper").SELECTED_PRODUCT;
  PRODUCT_NAMES = require("../llm-whisperer/helper").PRODUCT_NAMES;
  llmWhispererContentImage = require("../assets/llmWhisperer/llm-whisperer-content-image.png");
} catch {
  // The component will remain undefined if it is not available
}

const DEFAULT_TRIAL_MSG =
  "Try Unstract free for 14 days. No credit card required.";

function LoginForm({ handleLogin }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedProduct = queryParams.get(SELECTED_PRODUCT);
  const [content, setContent] = useState({});
  const [trialMsg, setTrialMsg] = useState(DEFAULT_TRIAL_MSG);

  useEffect(() => {
    if (selectedProduct && selectedProduct === PRODUCT_NAMES?.llmWhisperer) {
      setContent({
        title: "Get complex documents ready for LLM consumption",
        description:
          "LLMWhisperer is available as an API that can be integrated into your existing systems to preprocess your documents before they are fed into LLMs. It can handle a variety of document types, including PDFs, images, and scanned documents.",
      });
      setTrialMsg(
        "Process up to 100 pages daily at no cost. No credit card required."
      );
    }
  }, [selectedProduct]);

  return (
    <>
      <Col xs={24} md={12} className="login-left-section">
        <div className="button-wraper">
          <>
            <Space direction="vertical" size={30}>
              <LoginLogo
                selectedProduct={selectedProduct}
                productNames={PRODUCT_NAMES}
              />
              {SwitchRegion && <SwitchRegion />}
              <div className="text-wrapper">
                <Typography.Title level={3}>Sign Up</Typography.Title>
                {TrialMessage && <TrialMessage msg={trialMsg} />}
              </div>
            </Space>
            <Button className="login-button" onClick={handleLogin}>
              Create Your free account
            </Button>
            <div className="signin-text-wrapper">
              <Typography>Already have an account?</Typography>
            </div>
            <Button className="signin-button" onClick={handleLogin}>
              Sign in
            </Button>
          </>
        </div>
      </Col>
      <Col xs={24} md={12} className="login-right-section">
        {Object.keys(content)?.length && llmWhispererContentImage ? (
          <ProductContentLayout
            title={content?.title}
            description={content?.description}
            image={llmWhispererContentImage}
          />
        ) : (
          <ProductContentLayout />
        )}
      </Col>
    </>
  );
}

LoginForm.propTypes = {
  handleLogin: PropTypes.func.isRequired,
};
export { LoginForm };
